import { render, staticRenderFns } from "./deposite.vue?vue&type=template&id=2573edb1&scoped=true"
import script from "./deposite.vue?vue&type=script&lang=ts"
export * from "./deposite.vue?vue&type=script&lang=ts"
import style0 from "./deposite.vue?vue&type=style&index=0&id=2573edb1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2573edb1",
  null
  
)

export default component.exports